export default __webpack_public_path__ + "static/media/algolia.90fcc973.svg";